import React from "react";
import { createRoot } from "react-dom/client";
import "./style/root.css";
import "./style/components.css";
import "./style/page.css";
import "./style/introjs.css";
import "./style/animations.css";
import App from "./components/App";
import "./services/i18n.js"; // Import the i18n configuration

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
